import {
  useOfflineQueue
} from "../providers/offlineQueueProvider";
import {
  Toast,
  ToastContainer,
  Modal,
  ProgressBar
} from "react-bootstrap";

const OfflineQueueNotifier = () => {
  const {
    isSyncing,
    progress,
    syncStatus
  } = useOfflineQueue();

  return (
    <>
      <ToastContainer position="bottom-center" className="p-3">
        {syncStatus === "success" && (
          <Toast bg="success">
            <Toast.Body>✅ Dane zostały pomyślnie zsynchronizowane z serwerem.</Toast.Body>
          </Toast>
        )}
        {syncStatus === "error" && (
          <Toast bg="danger">
            <Toast.Body className="text-white">
              ❌ Niektóre dane nie zostały zsynchronizowane. Spróbuj ponownie później.
            </Toast.Body>
          </Toast>
        )}
      </ToastContainer>

      <Modal show={isSyncing} backdrop="static" keyboard={false} centered>
        <Modal.Header>
          <Modal.Title>Wysyłanie oczekujących danych</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Wysyłanie zapisanych danych do serwera...</p>
          <ProgressBar
            now={(progress.current / progress.total) * 100}
            label={`${progress.current} z ${progress.total}`}
            animated
            striped
          />
        </Modal.Body>
      </Modal>

    </>
  );
};

export default OfflineQueueNotifier;
